/** Browser request budget for NUX operations that may consume provider-native retries. */
export const BILLING_REQUEST_TIMEOUT_MS = 90_000;
